<h2 mat-dialog-title>{{ 'catalog.confirmation.title' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  <p>
    {{ 'catalog.confirmation.hint' | translate }}
  </p>
</mat-dialog-content>
<mat-dialog-actions class="mt-[8px]" align="end">
  <button
    class="mr-[8px]"
    dsw-secondary-button
    dsw-small-button
    mat-dialog-close
  >
    {{ 'common.cancel' | translate }}
  </button>
  <button
    dsw-primary-button
    dsw-small-button
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    {{ 'common.continue' | translate }}
  </button>
</mat-dialog-actions>
